import type { ImageBlockContent } from "../types"
import { Input } from "@/components/ui/input"
import { Label } from "@/components/ui/label"
import { Card, CardContent, CardHeader } from "@/components/ui/card"

interface ImageBlockEditorProps {
  content: ImageBlockContent | null
  onChange: (content: ImageBlockContent) => void
}

export function ImageBlockEditor({ content, onChange }: ImageBlockEditorProps) {
  const c = content ?? {}
  const update = (partial: Partial<ImageBlockContent>) =>
    onChange({ ...c, ...partial })

  return (
    <Card>
      <CardHeader>
        <h3 className="text-base font-medium">Image</h3>
      </CardHeader>
      <CardContent className="space-y-4">
        <div>
          <Label>Image URL</Label>
          <Input
            value={c.url ?? ""}
            onChange={(e) => update({ url: e.target.value || undefined })}
            placeholder="https://..."
          />
        </div>
        <div>
          <Label>Alt text</Label>
          <Input
            value={c.alt ?? ""}
            onChange={(e) => update({ alt: e.target.value })}
            placeholder="Describe the image"
          />
        </div>
        <div>
          <Label>Caption (optional)</Label>
          <Input
            value={c.caption ?? ""}
            onChange={(e) => update({ caption: e.target.value || undefined })}
            placeholder="Caption below the image"
          />
        </div>
      </CardContent>
    </Card>
  )
}
